import { createContext } from 'react';
import { ITranslationSchema } from '../../interfaces/ITranslationFields';

const TranslationContext = createContext<ITranslationSchema | {}>({});

export default TranslationContext;
